import { memo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

import { TriggerButton } from "widgets";

import { type IJobState, rerunJob } from "../../redux/modules/job.js";
import { type IAppState } from "../../redux/reducer.js";
import { type ReduxDispatch } from "../../redux/redux-utils.js";

/**
 * The Re-run button to allow re-execution of BLAST jobs
 */
function ReRunBlastButtonHeader() {
  const dispatch = useDispatch<ReduxDispatch>();
  const { job } = useSelector<IAppState, IJobState>((state) => state.job, shallowEqual);

  return (
    <TriggerButton
      key={"rerun-blast-button"}
      icon={"redo"}
      onPress={() => dispatch(rerunJob(job.id))}
      label={"Re-Run"}
      showLabel
    />
  );
}

export default memo(ReRunBlastButtonHeader);
